import { ref, watch } from "vue";
import { durableGetItem, durableHas, durableSetItem } from "./durableStorage";

export const printAfterAccept = ref(true);
if (durableHas('PRINT_AFTER_ACCEPT')) {
    printAfterAccept.value = durableGetItem('PRINT_AFTER_ACCEPT') === 'true';
}
watch(printAfterAccept, (newVal: boolean) => {
    durableSetItem('PRINT_AFTER_ACCEPT', newVal.toString());
});

export const printOrderOnPlaced = ref(false);
if (durableHas('PRINT_ORDER_ON_PLACED')) {
    printOrderOnPlaced.value =
        durableGetItem('PRINT_ORDER_ON_PLACED') === 'true';
}
watch(printOrderOnPlaced, (newVal: boolean) => {
    durableSetItem('PRINT_ORDER_ON_PLACED', newVal.toString());
});

export const copies = ref(1);
if (durableHas('COPIES_NUMBER')) {
    copies.value = Number(durableGetItem('COPIES_NUMBER')) || 1;
}

watch(copies, (newVal: number) => {
    durableSetItem('COPIES_NUMBER', newVal.toString());
});